export const SET_TOKEN = 'auth/setToken';
export const SET_USER = 'auth/setUser';
export const SET_PERMISSIONS = 'auth/setPermissions';
export const UPDATE_USER = 'auth/updateUser';
